export default __webpack_public_path__ + "static/media/PRIM_oldExp.5f7835c1.md";